const en = {
  TITLE: "Finnhouse",
  DESCRIPTION: "Finnish competetive league of legends gaming community.",
  HEADER: {
    HOME: "Home",
    SCHEDULE: "Schedule",
    RESULTS: "Results",
    SCOREBOARD: "Scoreboards",
    TEAMS: "Teams",
    GALLERY: "Gallery",
    ABOUT: "About us",
    PLAYERS: "Players",
    LEADERBOARD: "Ranked",
    STATS: "Stats",
    CHAMPIONS: "Champion stats",
  },
  SCOREBOARD: {
    GRID_PLACEMENT: "P",
    GRID_TEAM_NAME: "Team",
    GRID_SERIES_WINS: "Series Wins",
    GRID_SERIES_LOSSES: "Series Losses",
    GRID_GAME_WINS: "Game Wins",
    GRID_GAME_LOSSES: "Game Losses",
    GRID_SERIES_WINS_SHORT: "S W",
    GRID_SERIES_LOSSES_SHORT: "S L",
    GRID_GAME_WINS_SHORT: "G W",
    GRID_GAME_LOSSES_SHORT: "G L",
    GRID_TEAM_WINS: "W",
    GRID_TEAM_LOSSES: "L",
    FPL_REGULAR_PLACEMENTS_TITLE: "FPL Regular Season",
    FPL_PLAYOFFS_PLACEMENTS_TITLE: "FPL PlayOffs",
    FPL_RELEGATIONS_PLACEMENTS_TITLE: "FPL Relegations",
    NO_TEAMS_AVAILABLE: "Failed to display results.",
  },
  PLAYOFFCHART: {
    FINAL_UPPERBRACKET_WINNER: "Upper Bracket Winner",
    FINAL_LOWERBRACKET_WINNER: "Lower Bracket Winner",
    LOSER_UPPERBRACKET: "Loser of Uppper R",
    WINNER_LOWERBRACKET: "Winner of Lower R",
    FINAL: "Grand Final",
    FINALIST: "CHAMPIONSHIP",
    ROUND: "ROUND",
    UPPER_BRACKET: "UPPER BRACKET",
    LOWER_BRACKET: "LOWER BRACKET",
  },
  TEAMS: {
    TITLE: "Finnish pro league",
    NO_TEAMS_TO_SHOW: "No teams to show",
    NO_DESCRIPTION: "No description given",
    PRIMARY_ROSTER: "Primary roster",
    SUBSTITUTES: "Substitutes",
    DIRECTORY_SUBTITLE: "Select a team to view roster, match history, and season placements.",
    VIEW_TEAM: "View {team} team page",
    VIEW_TEAM_SHORT: "Open team →",
    BACK_TO_TEAMS: "← Back to teams",
    LOADING: "Loading team…",
    LOAD_ERROR: "Could not load team details.",
    NOT_FOUND: "Team not found.",
    TAB_ROSTER: "Roster",
    TAB_HISTORY: "Match history",
    TAB_PLACEMENTS: "Season placements",
    TABS_LABEL: "Team sections",
    SOCIALS_LABEL: "Team links",
    HIGHLIGHT_SEASONS: "Seasons",
    HIGHLIGHT_TITLES: "Titles",
    HIGHLIGHT_MATCHES: "Matches",
    NO_ROSTER: "No roster players available.",
    NO_MATCH_HISTORY: "No played matches found for this team.",
    NO_CHAMPIONS: "No champ data",
    CHAMPIONS_LABEL: "Champions played",
    GAME_CHAMPS_LABEL: "Game {number} champions",
    TEAM_CHAMPIONS_LABEL: "Your team champions",
    OPPONENT_CHAMPIONS_LABEL: "Opponent champions",
    RESULT_WIN: "W",
    RESULT_LOSS: "L",
    RESULT_DRAW: "D",
    HISTORY_ROW_LABEL: "Open match vs {opponent}, score {score}",
    NO_PLACEMENTS: "No season placement history found for this team.",
    FILTER_SEASON: "Season",
    ALL_SEASONS: "All seasons",
    COLUMN_SEASON: "Season",
    COLUMN_PLACE: "Place",
    COLUMN_RECORD: "Series",
    COLUMN_GAMES: "Games",
    COLUMN_RESULT: "Result",
    PLACE: "#{place}",
    PLACE_NA: "—",
    CHAMPION: "Champion",
    REGULAR_SEASON: "Regular season",
  },
  PLAYERS: {
    HEADER: "Player Ratings on EUW Ladder",
  },
  PLAYER_PAGE: {
    CHAMPIONS: "Champions",
    UNIQUE_CHAMPS: "{count} champs",
    SHOW_MORE_CHAMPS: "Show more ({count})",
    SHOW_LESS_CHAMPS: "Show less",
    MULTIKILL: "MK",
    ROLE: "Role",
    VIEW_MATCH: "View match details",
  },
  LIVE: {
    TITLE: "LIVE BROADCAST!",
    LIVE_NOW_TITLE: "CURRENTLY LIVE",
    VIEWERS: "{count} viewers",
    LOADING: "Checking Twitch status…",
    CHAT_TITLE: "Twitch chat",
    LIVE_BADGE: "Live",
    FOLLOW_TWITCH: "Follow us on Twitch",
    EXPAND: "Expand",
    COLLAPSE: "Collapse",
    SHOW_CHAT: "Show chat",
    HIDE_CHAT: "Hide chat",
    OPEN_BOTH_STREAMS: "Open both streams",
    POP_OUT: "Pop out",
    DOCK: "Dock",
    POPOUT_ACTIVE: "Stream is playing in the pop-out player.",
  },
  GALLERY: {
    VIEW_MORE: "VIEW MORE",
  },
  TRACKER: {
    DAYS: "days",
    HOURS: "hours",
    MINUTES: "minutes",
    SECONDS: "seconds",
    LIVE: "GAME IS LIVE",
    LIVE_MATCHES: "LIVE MATCHES",
    NEXT_MATCH: "NEXT MATCH",
    NO_CONTENT: "NEW FPL SEASON STARTS NEXT YEAR",
  },
  COMMON: {
    VS: "VS",
    TBD: "TBD",
    TEAM_LOGO_ALT: "{team} logo",
    SKIP_TO_CONTENT: "Skip to main content",
  },
  HERO: {
    MAP_ALT: "Map of Finland",
  },
  DESCRIPTION_SECTION: {
    BODY: "Finnhouse is a Finnish League of Legends community and tournament organizer that builds a player-driven esports culture with heart and together with the community.",
    MAP_DESC: "THE FINNISH LOL HUB",
    RIFT_DESC: "HOME OF COMPETITIVE PLAY",
    PORO_DESC: "BUILT TOGETHER",
    MAP_ALT: "Finnish map icon",
    RIFT_ALT: "Summoner's Rift icon",
    PORO_ALT: "Poro from League of Legends",
  },
  BUTTONS: {
    READ_MORE: "READ MORE",
  },
  WEEKDAYS: {
    MON: "Monday",
    TUE: "Tuesday",
    WED: "Wednesday",
    THU: "Thursday",
    FRI: "Friday",
    SAT: "Saturday",
    SUN: "Sunday",
  },
  MONTHS: {
    JAN: "January",
    FEB: "February",
    MAR: "March",
    APR: "April",
    MAY: "May",
    JUN: "June",
    JUL: "July",
    AUG: "August",
    SEP: "September",
    OCT: "October",
    NOV: "November",
    DEC: "December",
  },
  NEWS: {
    NEWS_TITLE: "News",
    SCHEDULE: "Schedule",
    NO_UPCOMING_MATCHES: "No upcoming matches",
    SCHEDULE_EMPTY_HINT: "Next season's matches will appear here.",
    MATCH: "Week",
  },
  UPCOMING: {
    FILTER: "Filter by team",
  },
  FOOTER: {
    CONTACT: "GET IN TOUCH",
    CONTACT_DESCRIPTION: "Questions? You can contact us -",
    DISCORD: "ON DISCORD USERNAME:",
    EMAIL: "BY EMAIL",
    LINKS: "SOCIAL LINKS",
    INFO: "INFORMATION & POLICIES",
    TERMS: "Terms of Use",
    PRIVACY: "Privacy Policy",
    COOKIES: "Cookie Settings",
    SPONSORS: "PARTNERS",
    COPY: "Click to copy",
    COPIED: "COPIED",
    COPYRIGHT: "All rights reserved.",
  },
  COOKIES: {
    TITLE: "Cookies",
    SETTINGS_TITLE: "Cookie settings",
    DESCRIPTION:
      "We use optional cookies to help improve the website and how it works for visitors. If you accept, we set a session cookie for this purpose (no name or email). Basic visit and unique-visitor counts still run without cookies using our own server-side analytics. You can accept or reject optional cookies.",
    ACCEPT: "Accept",
    REJECT: "Reject",
    CLOSE: "Close",
  },
  LEGAL: {
    TERMS: {
      TITLE: "Terms of Use",
      UPDATED: "Last updated: 29 July 2026",
      INTRO:
        "These terms apply to the Finnhouse website (finnhouse.fi) operated by the Finnhouse community. By using the site, you agree to these terms.",
      SECTIONS: [
        {
          TITLE: "About Finnhouse",
          BODY: "Finnhouse organizes Finnish League of Legends competitions and community activities, including leagues such as FPL, FCL, and FHL. The website publishes schedules, results, statistics, team information, broadcasts, and related content.",
        },
        {
          TITLE: "Use of the website",
          BODY: "You may use the website for personal, non-commercial purposes. Do not attempt to disrupt the service, scrape data in ways that overload our systems, bypass security, or use the site for unlawful activity. Admin tools are reserved for authorized staff only.",
        },
        {
          TITLE: "Content and accuracy",
          BODY: "Match results, rankings, player statistics, and schedules are provided for information and community use. We work to keep information accurate, but data may be updated, corrected, or delayed. Content is provided as-is without guarantees of completeness or timeliness.",
        },
        {
          TITLE: "Intellectual property",
          BODY: "Finnhouse branding, website design, and original content belong to Finnhouse or its partners unless otherwise stated. League of Legends and related assets are trademarks of their respective owners. Do not copy, redistribute, or commercially reuse site content without permission.",
        },
        {
          TITLE: "Third-party links and services",
          BODY: "The site may link to external platforms such as Twitch, YouTube, Discord, and partner websites. We are not responsible for third-party content or services.",
        },
        {
          TITLE: "Limitation of liability",
          BODY: "Finnhouse is not liable for indirect or consequential damages arising from use of the website. To the extent permitted by law, our liability is limited to issues caused by intent or gross negligence.",
        },
        {
          TITLE: "Changes and contact",
          BODY: "We may update these terms when the service changes. Continued use after updates means you accept the revised terms. Questions: finnhouse@gmail.com or Discord user FLOORA.",
        },
      ],
    },
    PRIVACY: {
      TITLE: "Privacy Policy",
      UPDATED: "Last updated: 29 July 2026",
      INTRO:
        "This policy explains how Finnhouse handles information when you use finnhouse.fi. We aim to collect only what is needed to run the site and improve it.",
      SECTIONS: [
        {
          TITLE: "Data controller",
          BODY: "Finnhouse community\nContact: finnhouse@gmail.com\nDiscord: FLOORA",
        },
        {
          TITLE: "Information we process",
          BODY: "Depending on how you use the site, we may process:\n• Technical request data needed to deliver pages (e.g. browser type, approximate timing)\n• Admin login credentials for authorized staff\n• Aggregated visit statistics and estimated unique visitors using a short-lived server-side daily hash (no cookies; we do not store your raw IP address)\n• With consent: a session cookie that helps us improve the website",
        },
        {
          TITLE: "Cookies and similar technologies",
          BODY: "Optional cookies are used to help improve the website only if you accept them in the cookie banner. You can reopen cookie settings from the footer at any time. Rejecting optional cookies turns off that improvement-related tracking. Basic visit counts and estimated unique visitors still run without cookies.",
        },
        {
          TITLE: "Our analytics",
          BODY: "We use first-party analytics on our own servers. Every visit increments daily totals. To estimate unique visitors without cookies, our server creates a day-scoped pseudonymous key from technical request data (such as IP address and browser type), immediately hashes it, and stores only that hash — not your raw IP. If you accept cookies, we may also use a session cookie to support website improvement. We do not collect your name, email, or public user account for analytics.",
        },
        {
          TITLE: "Improving the website",
          BODY: "We use aggregated analytics and, with your consent, optional cookie-based data to improve Finnhouse — for example to fix issues, refine features, and make the site clearer and more useful. We do not sell personal data or use these analytics to build individual marketing profiles.",
        },
        {
          TITLE: "Legal bases (EU/EEA)",
          BODY: "We rely on legitimate interest for basic site operation, aggregated statistics, and estimated unique visitors using short-lived server-side hashes. Optional cookies used to help improve the site are used only with your consent. Admin authentication is based on contractual/necessary processing for site administration.",
        },
        {
          TITLE: "Retention",
          BODY: "Analytics rollups are kept in aggregated form for service improvement. Visitor hashes change daily and are not used to build long-term profiles. Session cookies expire when you close the browser. Admin logs and operational data are retained only as long as needed.",
        },
        {
          TITLE: "Your rights",
          BODY: "If GDPR applies, you may have rights to access, rectify, erase, restrict, or object to certain processing, and to withdraw consent for optional cookies. Contact us at finnhouse@gmail.com. You may also lodge a complaint with your local data protection authority.",
        },
        {
          TITLE: "Changes",
          BODY: "We may update this policy when our site, cookies, or analytics change. The latest version is always published on this page.",
        },
      ],
    },
  },
  ABOUT: {
    INTRODUCTION: {
      TITLE: "WHAT IS FINNHOUSE?",
      PARAGRAPH: {
        ONE: "Finnhouse was founded in 2021 with the desire to build a better home for the Finnish League of Legends scene. Over the years, we have grown from a small community project into Finland’s largest LoL-based tournament organizer.",
        TWO: "Our leagues – FPL, FCL, and FHL – offer gaming experiences both for those aiming for the top and for those seeking a more casual vibe. We have organized dozens of tournaments, produced hundreds of broadcasts, and built our operations together with volunteers, players, and fans.",
        THREE:
          "Finnhouse is more than just a league – it’s a community dedicated to developing Finnish esports with a player-first mindset and passion.",
      },
    },
    POINTS: {
      EYEBROW: "What we do",
      SECTION_TITLE: "More than tournaments",
      SECTION_SUBTITLE:
        "Finnhouse builds spaces for competition, community, and growth across the Finnish LoL scene.",
      ONE: {
        TITLE: "The Finnish LoL Hub",
        PARAGRAPH:
          "Finnhouse brings together the Finnish League of Legends community – players, teams, and fans.",
      },
      TWO: {
        TITLE: "Home of Competitive Play",
        PARAGRAPH:
          "We organize leagues, tournaments, and events – from casual matches to LAN finals.",
      },
      THREE: {
        TITLE: "Built Together",
        PARAGRAPH:
          "Our activities grow through volunteer effort. Everyone can participate and make an impact – the community is at the core.",
      },
    },
    CASTERS: {
      EYEBROW: "The team",
      TITLE: "Who we are at Finnhouse",
      SUBTITLE: "The voices and faces behind our broadcasts, events, and community.",
      ROLE: {
        CASTER: "Caster",
        HOST: "Host",
      },
      NO_CASTERS: "Failed to display casters.",
    },
  },
  LATEST_GAMES: {
    TITLE: "Upcoming Games",
  },
  RECENT_GAMES: {
    TITLE: "Recent Games",
    NO_RECENT_GAMES_AVAILABLE: "No recent games available.",
    VIEW_ALL: "View all results",
  },
  SCHEDULE: {
    VIEW_FULL: "View full schedule",
    PAGE_TITLE: "Schedule",
    PAGE_SUBTITLE: "All upcoming matches",
    LOADING: "Loading schedule…",
    WATCH_STREAM: "Watch on Twitch",
    STREAM_TBD: "Stream channel TBD",
    WATCH_VOD: "Watch on YouTube",
    VIEW_MATCH_DETAILS: "View match details",
    FILTER_TEAMS: "Filter by team",
    CLEAR_FILTER: "Clear filter",
    NO_FILTER_RESULTS: "No matches for selected teams",
    NO_FILTER_RESULTS_HINT: "Try selecting different teams or clear the filter.",
  },
  MATCH_DETAIL: {
    LOADING: "Loading match…",
    LOAD_ERROR: "Failed to load match data.",
    NOT_FOUND: "Match not found.",
    INVALID_MATCH: "Invalid match link.",
    BACK_TO_RESULTS: "← Back to results",
    GAME_TABS: "Games in series",
    GAME_TAB: "Game {number}",
    GAME_TITLE: "Game {number}",
    WINNER_LABEL: "{team} won",
    WINNER_SHORT: "{team} W",
    NO_GAMES: "No game data for this match yet",
    NO_GAMES_HINT:
      "Individual game stats appear here once Riot game IDs are scraped for this series.",
    VICTORY: "Victory",
    DEFEAT: "Defeat",
    KILLS: "Kills",
    OBJECTIVES: "Team objectives",
    TURRETS: "Turrets",
    DRAGONS: "Dragons",
    BARONS: "Barons",
    GRUBS: "Grubs",
    HERALD: "Herald",
    ELDERS: "Elders",
    YES: "Yes",
    NO: "No",
    BANS: "Bans",
    NO_BAN: "No ban",
    PLAYER_STATS: "Player performance",
    CHAMPION: "Champ",
    PLAYER: "Player",
    DAMAGE: "Damage",
    GOLD: "Gold",
    VISION: "Vision",
    ITEMS: "Items",
    CS_PER_MIN: "/min",
    CS15_DIFF: "CS@15 Δ",
    DPM: "DPM",
    DRAGON_TYPES: "Dragons taken",
    BANNED_CHAMPION: "Banned champion {id}",
    GRAPHS: "Graphs",
    GRAPHS_TITLE: "Post-game graphs",
    GRAPHS_DAMAGE: "Damage to champions",
    GRAPHS_GOLD: "Gold earned",
    GRAPHS_CS: "Creep score",
    GRAPHS_VISION: "Vision score",
    GRAPHS_DPM: "Damage per minute",
    GRAPHS_KP: "KP%",
    GRAPHS_CHAMPION_ALT: "{champion} champion icon",
    CS: "CS",
  },
  RESULTS: {
    PAGE_TITLE: "Results",
    PAGE_SUBTITLE: "Season standings and played matches",
    FILTER_SEASON: "Season",
    MATCHES_TITLE: "Played matches",
    CURRENT_SEASON_LIVE: "live",
    LOADING: "Loading results…",
    NO_RESULTS: "No played matches yet",
    NO_RESULTS_HINT: "Results will appear here once matches are completed.",
    NO_SEASON_RESULTS: "No played matches for this season",
    NO_SEASON_RESULTS_HINT: "Try another season or check back after more games are played.",
    NO_FILTER_RESULTS: "No matches for selected teams",
    NO_FILTER_RESULTS_HINT: "Try selecting different teams or clear the filter.",
  },
  LEADERBOARD: {
    PAGE_TITLE: "FPL Ranked",
    TAB_LEADERBOARD: "Ranked",
    TAB_RISERS: "Risers & Fallers",
    RISERS_DESCRIPTION:
      "Largest player LP changes since midnight for the selected day, or for a full week (Mon–Sun, Helsinki). Today's totals update live every 15 minutes.",
    LIVE_RANKINGS: "Live rankings",
    RANKS_REFRESHED: "Ranks refreshed {time}",
    SAME_AS_TEAM_PAGES: "Same data as team pages",
    LAST_UPDATED: "Last updated",
    NO_RANK_DATA: "No rank data yet",
    STANDINGS: "Standings",
    HISTORY: "History",
    ERROR_LOAD: "Failed to load ranked data",
    LOADING: "Loading…",
    NO_TEAMS: "No FPL teams with player data found.",
    TAB_TEAMS: "Teams",
    TAB_INDIVIDUAL: "Individual",
    FILTER_TEAM: "Team",
    FILTER_ROLE: "Role",
    ALL_PLAYERS: "All players",
    ALL_ROLES: "All roles",
    SOLO_DUO: "Solo / Duo",
    COLUMN_TEAM: "Team",
    COLUMN_PLAYER: "Player",
    COLUMN_RANK: "Rank",
    COLUMN_WINRATE: "Winrate",
    ACTIVE_ROSTER: "Active roster",
    SUBSTITUTES: "Substitutes",
    VIEW_OPGG: "View on OP.GG →",
    SUB_BADGE: "Sub",
    UNRANKED: "Unranked",
    LP: "LP",
    RANK_EMBLEM_ALT: "{tier} rank emblem",
    PROFILE_ICON_ALT: "Player profile icon",
    PERIOD_DAY: "Day",
    PERIOD_WEEK: "Week",
    PERIOD_GROUP: "Period",
    PICKER_DAY: "Day",
    PICKER_WEEK: "Week",
    NO_DAYS_YET: "No days yet",
    NO_WEEKS_YET: "No weeks yet",
    DAILY_TODAY: "Today",
    WEEKLY_THIS_WEEK: "This week",
    DAILY_LIVE_BADGE: "Live",
    DAILY_UPDATED_THROUGH: "Total LP change since midnight · updated {time}",
    WEEKLY_UPDATED_THROUGH: "Total LP change since Monday · updated {time}",
    VIEW_PLAYER_OPGG: "View {player} on OP.GG",
    VIEW_PLAYER_PROFILE: "View {player} FPL stats",
    VIEW_PLAYER_RANK_SITE: "View {player} on {site} (solo queue)",
    ERROR_LOAD_MOVERS: "Failed to load movers",
    EMPTY_DAILY_WAIT:
      "Daily LP changes appear after the midnight snapshot and the first update of the day.",
    EMPTY_DAILY_NO_CHANGES: "No LP changes on the selected day.",
    EMPTY_DAILY_NO_SNAPSHOTS: "No comparable snapshots found for the selected day.",
    EMPTY_WEEKLY_WAIT:
      "Weekly LP changes appear after the Monday snapshot and the first update of the week.",
    EMPTY_WEEKLY_NO_CHANGES: "No LP changes on the selected week.",
    EMPTY_WEEKLY_NO_SNAPSHOTS: "No comparable snapshots found for the selected week.",
    TOP_DAILY_GAINERS: "Top daily gainers",
    TOP_WEEKLY_GAINERS: "Top weekly gainers",
    TOP_DAILY_LOSERS: "Top daily losers",
    TOP_WEEKLY_LOSERS: "Top weekly losers",
    NO_HISTORY: "No history yet. Snapshots are saved at the start and end of each day.",
    TIMELINE: "Timeline",
    TIMELINE_ARIA: "Chart timeline",
    GRANULARITY_INTRADAY: "15 min",
    GRANULARITY_DAILY: "Daily",
    GRANULARITY_WEEKLY: "Weekly",
    POINTS: "{count} points",
    POINT_SINGULAR: "{count} point",
  },
  SEASON_STATS: {
    TITLE: "FPL Season Stats",
    DESCRIPTION:
      "Compare all players from the selected season. Filter by role or team and sort by any stat column.",
    SEASON: "Season",
    NO_SEASON_DATA: "No season data",
    PLAYERS: "Players",
    FILTER_SEASON: "Season",
    FILTER_TEAM: "Team",
    FILTER_ROLE: "Role",
    FILTER_ROSTER: "Roster",
    ALL_TEAMS: "All teams",
    ALL_ROLES: "All roles",
    ALL_PLAYERS: "All players",
    MAIN_ROSTER_ONLY: "Main roster only",
    SUBSTITUTES_ONLY: "Substitutes only",
    BENCHED_ONLY: "Benched only",
    LOADING: "Loading stats…",
    ERROR_SEASONS: "Season stats could not be loaded.",
    ERROR_PLAYERS: "Player stats could not be loaded.",
    NO_RESULTS: "No player stats for the selected filters.",
    CURRENT_SEASON_LIVE: "live",
    CURRENT_SEASON_NOTE: "Stats from played games so far this season.",
    COLUMNS: {
      PLAYER: "Player",
      TEAM: "Team",
      ROLE: "Role",
      GAMES: "Games",
      CHAMPS: "Champs",
      DOUBLE: "Double",
      TRIPLE: "Triple",
      QUADRA: "Quadra",
      PENTA: "Penta",
    },
    ROLES: {
      Top: "Top",
      Jungle: "Jungle",
      Mid: "Mid",
      ADC: "ADC",
      Support: "Support",
      Fill: "Fill",
    },
  },
  SEASON_SPLITS: {
    WINTER: "Winter",
    SPRING: "Spring",
    SUMMER: "Summer",
    FALL: "Fall",
  },
  CHAMPION_STATS: {
    TITLE: "FPL Champion Stats",
    DESCRIPTION:
      "Every champion drafted in the selected season. Search by champion, filter by role and sort by any stat column.",
    SEASON: "Season",
    NO_SEASON_DATA: "No season data",
    CHAMPIONS: "Champions",
    FILTER_SEASON: "Season",
    FILTER_ROLE: "Role",
    FILTER_SEARCH: "Champion",
    ALL_ROLES: "All roles",
    ROLE_UNAVAILABLE: "Role data is not available for this season.",
    SEARCH_PLACEHOLDER: "Search champion…",
    LOADING: "Loading champions…",
    ERROR_SEASONS: "Season list could not be loaded.",
    ERROR_CHAMPIONS: "Champion stats could not be loaded.",
    NO_RESULTS: "No champions for the selected filters.",
    NO_SEASON_STATS:
      "No champion data for this season yet. Stats appear once games have been played.",
    RESULT_COUNT: "{count} champions found.",
    TABLE_CAPTION: "Champion stats for the selected season",
    CURRENT_SEASON_LIVE: "live",
    CURRENT_SEASON_NOTE: "Stats from played games so far this season.",
    COLUMNS: {
      CHAMPION: "Champion",
      PICKS: "Picked",
      BANS: "Banned",
      WINS: "W",
      LOSSES: "L",
      WINRATE: "WR%",
      PICK_PCT: "Pick%",
      BAN_PCT: "Ban%",
      PRESENCE: "Presence",
      GAMES: "Games",
    },
  },
  STAT_TIER_LEGEND: {
    TITLE: "Stat colors",
    INTRO:
      "Values are color-coded by performance tier (OP.GG-style). Each tier maps to orange → blue → green → grey → red, left to right below.",
    LABELS: {
      excellent: "Excellent",
      good: "Good",
      average: "Average",
      low: "Low",
      poor: "Poor",
    },
    STATS: {
      KDA: "KDA",
      K: "K",
      DEATHS: "D",
      ASSISTS: "A",
      CSM: "CS/m",
      KP: "KP%",
      DPM: "DPM",
    },
    THRESHOLDS: {
      KDA: "≥5 · ≥4 · ≥3 · ≥2 · <2",
      K: "≥5 · ≥4 · ≥3 · ≥2 · <2 avg",
      D: "≤2 · ≤2.75 · ≤3.5 · ≤4.5 · >4.5 avg (lower is better)",
      A: "≥8 · ≥6 · ≥4.5 · ≥3 · <3 avg",
      CSM: "≥8.5 · ≥7.5 · ≥6.5 · ≥5.5 · <5.5",
      KP: "≥75 · ≥65 · ≥55 · ≥45 · <45",
      DPM: "≥700 · ≥600 · ≥500 · ≥400 · <400",
    },
  },
  ADS: {
    PREVIEW_BADGE: "Ad preview",
    PREVIEW_BANNER_HINT: "Responsive banner · ~728×90 desktop, ~320×50 mobile",
    PREVIEW_FEED_HINT: "In-feed unit · sits between content blocks",
    PREVIEW_SIDEBAR_HINT: "Sidebar skyscraper · ~160×600, sticky on wide screens",
    PREVIEW_MOBILE_HINT: "Sticky mobile banner · stays at bottom while scrolling",
    LOAD_ERROR: "Ad could not load — check slot ID or AdSense approval",
  },
  TCG: {
    INTRO_TITLE: "FPL TCG cards",
    INTRO_BODY:
      "Browse the current FPL trading card set at the event. Tap a card to view it in detail.",
    ALL: "All",
    RARITY_STANDARD: "Standard",
    RARITY_LEGENDARY: "Legendary",
    RARITY_MYTHIC: "Mythic",
    RARITY_ULTIMATE: "Ultimate",
    EMPTY: "No cards in this category yet.",
    CLOSE: "Close image",
    PREV: "Previous card",
    NEXT: "Next card",
  },
  SEO: {
    HOME: {
      TITLE: "Finnhouse",
      DESCRIPTION:
        "Official website of the Finnish professional League of Legends league. Explore team and player statistics, upcoming matches, schedules, and the latest competitive updates.",
    },
    ABOUT: {
      TITLE: "About us",
      DESCRIPTION:
        "Learn about Finnhouse — Finland's largest LoL tournament organizer. FPL, FCL, and FHL leagues, broadcasts, and a player-first esports community since 2021.",
    },
    SCHEDULE: {
      TITLE: "Schedule",
      DESCRIPTION:
        "Upcoming Finnhouse matches and broadcast schedule. Filter by team and follow Finnish LoL league games on Twitch.",
    },
    RESULTS: {
      TITLE: "Results",
      DESCRIPTION:
        "Match results from Finnhouse leagues. Browse played series, scores, and links to detailed match stats and VODs.",
    },
    GALLERY: {
      TITLE: "Gallery",
      DESCRIPTION:
        "Photos and highlights from Finnhouse events, LAN finals, and Finnish League of Legends community gatherings.",
    },
    LEADERBOARD: {
      TITLE: "Ranked leaderboard",
      DESCRIPTION:
        "EUW ranked ladder tracking for Finnish pro league players. LP history, daily movers, and team-linked accounts.",
    },
    STATS: {
      TITLE: "Season stats",
      DESCRIPTION:
        "Player and team season statistics for Finnhouse leagues. KDA, damage, vision, and performance tiers by split.",
    },
    CHAMPIONS: {
      TITLE: "Champion stats",
      DESCRIPTION:
        "Champion picks, bans, winrate and presence by split in Finnhouse leagues, with KDA, CS/min and damage per champion.",
    },
    TEAMS: {
      TITLE: "Teams",
      DESCRIPTION:
        "Finnish pro league teams in Finnhouse. Rosters, descriptions, and links to players and social channels.",
    },
    TEAM: {
      TITLE: "Team",
      DESCRIPTION: "{team} roster, match history, and FPL season placements on Finnhouse.",
    },
    TERMS: {
      TITLE: "Terms of use",
      DESCRIPTION: "Terms of use for the Finnhouse website and services.",
    },
    PRIVACY: {
      TITLE: "Privacy policy",
      DESCRIPTION:
        "Privacy policy for the Finnhouse website — cookies, analytics, and data handling.",
    },
    NOT_FOUND: {
      TITLE: "Page not found",
      DESCRIPTION: "The page you requested could not be found on Finnhouse.",
      HOME_LINK: "Back to home page",
    },
    OG_IMAGE_ALT: "Finnhouse logo",
    MATCH: {
      TITLE: "Match",
      DESCRIPTION: "Match details, scoreboards, and stats for a Finnhouse series.",
    },
    PLAYER: {
      TITLE: "Player",
      DESCRIPTION: "Player profile, season stats, and match history on Finnhouse.",
    },
  },
};

export default en;
